const initialState = {
  resultsCustomQuestionList: [],
  resultsCustomQuestion: {},
  resultsCustomQuestionAdd: {},
  resultsCustomQuestionPatch: {},
  resultsCustomQuestionDelete: {},
  resultsCustomQuestionProductAdd: {},
  resultsCustomQuestionProducts: [],
  resultsCustomQuestionProductsDelete: {},
  resultsCustomQuestionsProductAdd: {},
  resultsCustomQuestionsProductDelete: {},
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_CUSTOM_QUESTION_RESPONSE_GET":
      newState.resultsCustomQuestionList = action.value;
      break;
    case "CUSTOM_QUESTION_RESPONSE_GET":
      newState.resultsCustomQuestion = action.value;
      break;
    case "CUSTOM_QUESTION_RESPONSE_RESET":
      newState.resultsCustomQuestion = {};
      break;
    case "CUSTOM_QUESTION_RESPONSE_ADD":
      newState.resultsCustomQuestionAdd = action.value;
      break;
    case "CUSTOM_QUESTION_RESPONSE_UPDATE":
      newState.resultsCustomQuestionPatch = action.value;
      break;
    case "CUSTOM_QUESTION_RESPONSE_DELETE":
      newState.resultsCustomQuestionDelete = action.value;
      break;
    case "CUSTOM_QUESTION_PRODUCT_RESPONSE_ADD":
      newState.resultsCustomQuestionProductAdd = action.value;
      break;
    case "CUSTOM_QUESTION_PRODUCTS_RESPONSE_GET":
      newState.resultsCustomQuestionProducts = action.value;
      break;
    case "CUSTOM_QUESTION_PRODUCTS_RESPONSE_DELETE":
      newState.resultsCustomQuestionProductsDelete = action.value;
      break;
    case "CUSTOM_QUESTIONS_PRODUCT_RESPONSE_ADD":
      newState.resultsCustomQuestionsProductAdd = action.value;
      break;
    case "CUSTOM_QUESTIONS_PRODUCT_RESPONSE_DELETE":
      newState.resultsCustomQuestionsProductDelete = action.value;
      break;
    case "RESET_CUSTOM_QUESTION_RESPONSES":
      newState.resultsCustomQuestionAdd = {};
      newState.resultsCustomQuestionPatch = {};
      newState.resultsCustomQuestionDelete = {};
      newState.resultsCustomQuestionsProductAdd = {};
      newState.resultsCustomQuestionsProductDelete = {};
      newState.resultsCustomQuestionProductsDelete = {};
      break;
    default:
      break;
  }
  return newState;
};

export default reducer;
